import type { OpportunityStatus, SingleOpportunity } from '@ps/isp-web-services-types';
import { RunnerStatusMarketDetails } from '@ps/isp-web-services-types';

import {
  sportsCompetition,
  sportsEvent,
  sportsMarket,
  sportsSelection,
  sportsSport
} from '../entities/index';
import type { Entity } from '../entities/index';
import { buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { getIsOddsBoostMarket } from './utils/getIsOddsBoostMarket';
import {
  getIsAvailableOpportunity,
  getIsSingleAvailableOpportunity
} from './utils/getIsOpportunity';
import { mergeWithTrackingContextValue } from './utils/mergeWithTrackingContextValue';

export const selectionRemoved = (context: TrackingContextValue, opportunity: SingleOpportunity) => {
  const runnerStatusMap: Record<OpportunityStatus, RunnerStatusMarketDetails> = {
    AVAILABLE: RunnerStatusMarketDetails.ACTIVE,
    SUSPENDED: RunnerStatusMarketDetails.SUSPENDED,
    UNAVAILABLE: RunnerStatusMarketDetails.REMOVED,
    RESTRICTED: RunnerStatusMarketDetails.ACTIVE
  };
  const entities: Entity[] = [
    sportsEvent({
      eventId: opportunity.eventId,
      eventStartTime: getIsSingleAvailableOpportunity(opportunity)
        ? new Date(opportunity.eventStartTime).getTime()
        : undefined
    }),
    sportsMarket({
      marketId: opportunity.runnerId.marketId,
      marketInPlay: getIsAvailableOpportunity(opportunity) ? opportunity.eventInPlay : false,
      marketIsOddsBoost: getIsAvailableOpportunity(opportunity)
        ? getIsOddsBoostMarket(opportunity.marketType)
        : false
    }),
    sportsSelection({
      selectionId: opportunity.runnerId.selectionId,
      selectionOdds: getIsAvailableOpportunity(opportunity)
        ? opportunity.winRunnerOdds?.decimalDisplayOdds?.decimalOdds
        : undefined,
      selectionStatus: runnerStatusMap[opportunity.status],
      isStartingPrice: false
    })
  ];

  const { eventTypeId, competitionId } = opportunity;

  if (eventTypeId) {
    entities.push(sportsSport({ sportId: eventTypeId }));
  }

  if (competitionId) {
    entities.push(sportsCompetition({ competitionId }));
  }
  context = mergeWithTrackingContextValue(context, entities);

  GAEvent({ action: 'Remove Selection' }, context);
  buttonClick({ buttonName: 'Remove Selection' }, context);
};
